import { EcommerceEvent, PortalProducts } from '~/analytics/types/analytics.type'

import { deleteCookie, getCookie } from '~/utils/cookie.utils'

import AnalyticsEvents_V2 from '../analyticsGA4'
import { TMP_EVENT_DOMAIN, TMP_EVENT_NAME } from '../constant'

import { PurchaseSubscriptionLogPayload } from './subscriptionAnalytics.types'

class SubscriptionAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.SUBSCRIPTION)
  }
  public event(action: string, params: Record<string, string | number | undefined>): void {
    this.logEvent({
      event: action,
      ...params,
    })
  }

  public logPurchase(data: {
    payload: PurchaseSubscriptionLogPayload
    isTrial?: boolean
    subscriptionType: string
    orderId: string
  }): void {
    const { payload, isTrial, subscriptionType, orderId } = data
    const { currency, revenue, items, invoiceNumber, coupon } = payload
    let type = subscriptionType

    switch (subscriptionType) {
      case 'month':
        type = 'monthly'
        break
      case 'year':
        type = 'yearly'
        break
      default:
        break
    }
    const eventId = getCookie(TMP_EVENT_NAME)
    if (!eventId) {
      return
    }
    const event = {
      event: 'purchase',
      is_trial: isTrial ?? false,
      type,
      order_id: orderId,
      eventId,
      ecommerce: {
        currency,
        transaction_id: invoiceNumber,
        value: revenue,
        items,
        coupon,
      },
    }

    this.logEvent(event)
    deleteCookie(TMP_EVENT_NAME, TMP_EVENT_DOMAIN)
  }

  // GA4 standard ecommerce funnel events. Emitted through logEcommerceEvent so they fan out to
  // GA4 (dataLayer) + PostHog + BigQuery and clear the dataLayer ecommerce object first.
  public logSelectItem(ecommerce: EcommerceEvent['ecommerce']): void {
    this.logEcommerceEvent({ event: 'select_item', ecommerce })
  }

  public logBeginCheckout(ecommerce: EcommerceEvent['ecommerce']): void {
    this.logEcommerceEvent({ event: 'begin_checkout', ecommerce })
  }

  // GA4's add_payment_info expects payment_type as an event-level param, not inside the ecommerce
  // object — so it goes through eventParams, which logEcommerceEvent flattens onto the event.
  public logAddPaymentInfo(paymentType: string, ecommerce: EcommerceEvent['ecommerce']): void {
    this.logEcommerceEvent({ event: 'add_payment_info', ecommerce, eventParams: { payment_type: paymentType } })
  }

  public logPayWall(): void {
    const event = {
      event: 'pay_wall',
    }

    this.logEvent(event)
  }

  public clickErrorCollapsible(): void {
    this.logButtonClick('subscription_error_collapsible')
  }
}

export default new SubscriptionAnalytics()
